/* eslint-disable react-hooks/exhaustive-deps */

import { Dispatch, memo, SetStateAction, useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Input from "../../../../components/Input";
import { service } from "../../service/service";
import Spinner from "../../../../components/Spinner/index";
import useAppData from "../../../../hook/useAppData";
import { SwitchBlue } from "../../../../libs/switch";
import { orderByName } from "../../../../libs/orderList";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import { IListProjects, INeedModalDelete } from "../../model";
import { ModalDelete } from "./components/ModalDeleteProject";
import { AutoCompleteList } from "../../../../libs/autoCompleteList";
import InputSelect from "../../../../components/Input-select";
import { CASE_FILTER_PROJECTS, SELECTFILTER_PROJECTS } from "./constants";
import Button from "../../../../components/Button";
import CardProjects from "./components/CardProjects";
import "./index.scss";
import { ACCESS } from "../../../Profile/constants";
import { CSVLink } from "react-csv";
import { toastError, toastSuccess } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";

function ListProjects() {
  const { token, accessIds } = useAppData();
  const [needSpinner, setNeedSpinner] = useState(true);

  const [ProjectsDeleted, setProjectsDeleted] = useState([] as IListProjects[]);
  const [ProjectsActivated, setProjectsActivated] = useState([] as IListProjects[]);
  const [inactiveOrActive, setInactiveOrActive] = useState(false);
  const [emptyFilter, setEmptyFilter] = useState(false);
  const [valueInput, setValueInput] = useState("");
  const [state, setState] = useState(false);
  const [needModalDelete, setNeedModalDelete] = useState<INeedModalDelete>({ status: false, id: 0 });
  const [nameModal, setNameModal] = useState<string>("");
  const [modalCsv, setModalCsv] = useState(false);

  const [ProjectsDeletedAux, setProjectsDeletedAux] = useState([] as IListProjects[]);
  const [ProjectsActivatedAux, setProjectsActivatedAux] = useState([] as IListProjects[]);

  const [selectFilter, setSelectFilter] = useState(0);

  useEffect(() => {
    setTimeout(() => getProjectsApi(), 500);
  }, []);

  function getProjectsApi() {
    let nomesArr: any = [];
    let nomesArrTrue: any = [];
    let nomesArrFalse: any = [];
    service.getProjects(token)?.then((data: any[]) => {
      data?.forEach((element: any) => {
        nomesArr.push(element);
        if (element?.is_deleted === true) {
          nomesArrTrue.push(element);
        }
        if (element?.is_deleted === false) {
          nomesArrFalse.push(element);
        }
      });
      const projectActiveOrderned = orderByName(nomesArrFalse, "name");
      const projectInactivedOrderned = orderByName(nomesArrTrue, "name");
      setProjectsDeleted(projectInactivedOrderned || nomesArrTrue);
      setProjectsActivated(projectActiveOrderned || nomesArrFalse);
      setProjectsDeletedAux(projectInactivedOrderned || nomesArrTrue);
      setProjectsActivatedAux(projectActiveOrderned || nomesArrFalse);
      setNeedSpinner(false);
    });
  }

  function handleFilterClick() {
    const projects = inactiveOrActive ? ProjectsDeletedAux : ProjectsActivatedAux;
    const filterList = projects?.filter((row) => {
      return row?.[CASE_FILTER_PROJECTS[selectFilter - 1]]?.toLowerCase()?.includes(valueInput?.toLowerCase());
    });
    inactiveOrActive ? setProjectsDeleted(filterList) : setProjectsActivated(filterList);

    if (filterList?.length === 0) {
      return setEmptyFilter(true);
    } else {
      return setEmptyFilter(false);
    }
  }

  function setStateFunction() {
    setNeedSpinner(true);
    setInactiveOrActive(!inactiveOrActive);
    setState(!state);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 400);
  }

  function TitleController() {
    return (
      <h1 className="list-projects-header__top__tittle">
        {inactiveOrActive ? `${ProjectsDeleted?.length} - Projetos inativos` : `${ProjectsActivated?.length} - Projetos ativos`}
      </h1>
    );
  }

  function handleToCleanFilter(event) {
    event.preventDefault();
    setValueInput("");
    getProjectsApi();
    setSelectFilter(0);
    setEmptyFilter(false);
  }

  return (
    <>
      <Toaster />
      <datalist id="dataList">
        {AutoCompleteList(inactiveOrActive ? ProjectsDeleted : ProjectsActivated, [CASE_FILTER_PROJECTS[selectFilter - 1]])?.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </datalist>
      <ModalPopUp
        title={`Projeto - ${nameModal}`}
        status={needModalDelete?.status}
        onClickCancel={() => setNeedModalDelete({ status: false, id: 0 })}
        className="modal-delete-project"
      >
        <ModalDelete
          needModalDelete={needModalDelete}
          setNeedModalDelete={setNeedModalDelete}
          setNameModal={setNameModal}
          getProjectsApi={getProjectsApi}
        />
      </ModalPopUp>
      <ModalPopUp
        title={<h3 className="font-bold -mb-8">Upload de Planilhas</h3>}
        status={modalCsv}
        onClickCancel={() => {
          setModalCsv(false);
        }}
        className="modal-sheet"
      >
        <ModalCsvAndXlsxUpload token={token} getProjectsApi={getProjectsApi} setModalCsv={setModalCsv} />
      </ModalPopUp>
      <div className="list-projects sm:min-h-40rem">
        <div className="list-projects-header">
          <div className="list-projects-header__top bg-primary">
            <TitleController />
            {accessIds.includes(ACCESS.PROJECT_write) ? (
              <div className="flex items-center gap-6">
                <Button onClick={() => setModalCsv(true)} className="bg-blue-50 border border-secondary text-secondary  flex-row flex">
                  CSV
                </Button>
                <Link className="list-projects-header__top__link bg-secondary sm:ml-0 hover:ease-in filter hover:brightness-90" to={"/projects/form"}>
                  Novo Projeto
                </Link>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="list-projects-filter sm:flex-wrap">
            <div className="flex items-center gap-5 sm:flex-wrap">
              <Input
                className="list-projects-filter__inputs min-w-150px max-w-300px sm:max-w-none text-textPrimary "
                name="filter-projects"
                label="Buscar projeto"
                setValue={(e) => setValueInput(e.target.value)}
                value={valueInput}
                type="search"
                placeholder="Busque um projeto"
                list="dataList"
                disabled={!!!selectFilter}
              />
              <InputSelect
                className="list-projects-filter__inputs min-w-150px max-w-300px sm:max-w-none"
                name="search"
                label="Filtro"
                placeholder="Pesquisar"
                value={selectFilter}
                onChange={(event: any) => setSelectFilter(event.target.value)}
                list={SELECTFILTER_PROJECTS}
              />
              <div className="list-projects-filter__box-buttons">
                <Button onClick={handleFilterClick} type="button" className={"bg-primary h-16"}>
                  Filtrar
                </Button>
                <Button className="bg-secondary h-16" onClick={handleToCleanFilter}>
                  Limpar
                </Button>
              </div>
            </div>

            <FormControlLabel
              className="list-projects-filter__switch"
              control={<SwitchBlue checked={state} onChange={setStateFunction} name="checkedB" />}
              label="Ver inativos"
            />
          </div>
        </div>
        <Spinner status={needSpinner}>
          {emptyFilter === false ? (
            <div className="list-projects__box lg:mt-12">
              <CardProjects projects={inactiveOrActive ? ProjectsDeleted : ProjectsActivated} setNeedModalDelete={setNeedModalDelete} />
            </div>
          ) : (
            <div className="flex justify-center">
              <h1 className="list-projects__nothing-list">Não há registros para a busca realizada.</h1>
            </div>
          )}
        </Spinner>
      </div>
    </>
  );
}

export default memo(ListProjects);

const CSV_MODEL = `Nome;Gerente de Projeto;Status;Data Final;Cliente;Imagem;Profissional;Tempo Alocado;Cargo
Projeto A;Gerente A;Ativo;;Cliente A;;profissional A;100;Cargo A
;;;;;;profissional B;50;Cargo A | Cargo B
;;;;;;profissional C;100;Cargo B
Projeto B;Gerente B;Ativo;;Cliente B;;profissional B;50;Cargo B
Projeto C;Gerente C;Concluído;01/01/2022;Cliente C;;profissional D;100;Cargo D
Projeto D;Gerente D;Cancelado;01/01/2022;Cliente D;;profissional C;100;Cargo D
`;

function ModalCsvAndXlsxUpload({
  token,
  getProjectsApi,
  setModalCsv,
}: {
  token: string;
  getProjectsApi: () => void;
  setModalCsv: Dispatch<SetStateAction<boolean>>;
}) {
  const handleUploadFile = async (e: any) => {
    if (!e?.target?.files[0]) return;
    if (
      !e?.target?.files[0]?.type.includes(".csv") &&
      !e?.target?.files[0]?.type.includes(".xlsx") &&
      !e?.target?.files[0]?.type.includes("sheet") &&
      !e?.target?.files[0]?.type.includes("excel")
    ) {
      return toastError("Esse arquivo não é um CSV nem um xlsx!");
    }
    const isCsvOrXlsx = e?.target?.files[0]?.type.includes(".csv") || e?.target?.files[0]?.name?.includes(".csv");
    const res = await service.uploadCsvAndXlsx({ file: e.target.files[0], token, path: isCsvOrXlsx ? "csv" : "xlsx" });
    if (!res?.ok) return toastError("Erro ao enviar arquivo!");
    getProjectsApi();
    toastSuccess("Arquivo enviado com sucesso!");
    setTimeout(() => {
      setModalCsv(false);
    }, 2000);
  };

  return (
    <div className="w-full h-full flex flex-row justify-between mt-8">
      <div className="h-full flex-col justify-between m-2 w-4/6 font-bold list-item">
        <h2 className="text-4xl mb-5">Instruções para fazer o upload do csv ou xlsx</h2>
        <ul className="text-2xl list-item">
          <li className="font-semibold flex my-9">
            <span>
              - Nome do Cliente e do Profissional devem ser <span className="font-bold font-familyPoppins px-1 underline">idênticos</span> ao
              cadastrado, caso contrário ficará vazio
            </span>
          </li>
          <li className="font-semibold my-9">
            - Para cadastrar mais de um Profissional ao mesmo projeto, preencha os dados do projeto na primeira linha deste mesmo projeto, nas linhas
            seguintes deixe os dados do projeto em vazio e preencha apenas os dados dos profissionais
          </li>
          <li className="font-semibold my-9">
            - Para Adicionar mais de um Cargo no Profissional, separe cada cargo pelo seguinte caractere: | (também conhecido como barra em pé) <br />
            Exemplo: ( Faxineiro | Gerente | Líder )
          </li>
          <li className="font-semibold my-9">
            - Tempo de Alocação deve ser informada em porcentagem, mas o símbolo de porcentagem (%) não deve ser inserido, apenas o número
          </li>
          <li className="font-semibold my-9">
            - A Imagem deve ser inserida apenas a url (link) da imagem, não deve ser inserido o nome da imagem ou o arquivo da mesma
          </li>
        </ul>
      </div>
      <div className="w-2/6 m-2 flex-col flex items-end mr-8">
        <div className="h-full mb-8 w-3/4 flex-col flex justify-around items-center">
          <div className="flex-col flex w-full">
            <p className="text-xl font-familyPoppins mb-8 text-center">Suba o Arquivo .csv ou .xlsx aqui</p>
            <label className="bg-primary flex w-full input-type-file h-14 justify-center items-center rounded-lg text-1.4rem font-bold font-sourceSansPro cursor-pointer transition duration-300 hover:ease-in filter hover:brightness-90">
              Upload CSV
              <input
                type="file"
                onChange={(e) => {
                  handleUploadFile(e);
                }}
                accept=".csv,.xlsx"
              />
            </label>
          </div>
          <div className="flex flex-col w-full">
            <p className="text-xl font-familyPoppins mb-8 text-center">Faça Download do modelo aqui</p>
            <CSVLink data={CSV_MODEL} filename={`modelo.csv`} target="_blank" className="text-primary">
              <Button className="bg-blue-100 border border-primary text-primary flex w-full">Baixar</Button>
            </CSVLink>
          </div>
        </div>
      </div>
    </div>
  );
}
